export default __webpack_public_path__ + "static/media/Standard42.a59180d9.png";